import { baseAxios } from "./Axios"


const request = async ()=>{
    const categorie = localStorage.getItem('categorie');
    const response = await baseAxios.get(`/check-winner?category=${categorie ? categorie : 'Aficionado'}`);
    return response;
}

const SetWinner = ()=>{
    request()
        .then((res)=>{
            const { iswinner, error } = res.data;
            if(!error){
                localStorage.setItem('winner-validate', true);
                //Set winner
                if(iswinner == "1"){
                    window.location.href = "/jugar/ganador";
                }else{
                    window.location.href = "/jugar/perdedor";
                }
            }
        }).catch(err=>{
            console.log(err);
        });
}

export { SetWinner }